<footer class="footer">
  <div class="text-center">
    <small class="copyright">Copyright 2021</small>
  </div><!--//container-->
</footer><!--//footer-->
